import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { HelmetProvider } from "react-helmet-async";
import { ShopProvider } from "./context/ShopContext";
import { LocaleProvider } from "./context/LocaleContext";
import Sidebar from "./components/Sidebar";
import { Footer } from "./components/Shared";
import Home from "./pages/Home";
import Shop from "./pages/Shop";
import ProductDetail from "./pages/ProductDetail";
import CartPage from "./pages/CartPage";
import CheckoutPage from "./pages/CheckoutPage";
import CheckoutSuccess from "./pages/CheckoutSuccess";
import Agenzia from "./pages/Agenzia";
import Team from "./pages/Team";
import Servizi from "./pages/Servizi";
import Portfolio from "./pages/Portfolio";
import PortfolioDetail from "./pages/PortfolioDetail";
import Contatti from "./pages/Contatti";
import AdminPage from "./pages/AdminPage";
import AccountLogin from "./pages/AccountLogin";
import AccountSetPassword from "./pages/AccountSetPassword";
import AccountPage from "./pages/AccountPage";
import LegalPage from "./pages/LegalPage";
import LocalSeoPro from "./pages/LocalSeoPro";
import AnalisiGoogle from "./pages/AnalisiGoogle";
import AnalisiGoogleGrazie from "./pages/AnalisiGoogleGrazie";
import NotFound from "./pages/NotFound";
import { AuthProvider } from "./context/AuthContext";

// Ogni pagina e' montata due volte: path IT (radice) e path EN (/en/... con slug
// tradotti). La lingua e' derivata dall'URL da LocaleProvider.
const ROUTE_DEFS = [
  { el: <Home />, it: "/", en: "/en" },
  { el: <Agenzia />, it: "/agenzia", en: "/en/about" },
  { el: <Team />, it: "/team", en: "/en/team" },
  { el: <Servizi />, it: "/servizi", en: "/en/services" },
  { el: <LocalSeoPro />, it: "/servizi/local-seo-pro", en: "/en/services/local-seo-pro" },
  { el: <AnalisiGoogle />, it: "/analisi-google", en: "/en/google-analysis" },
  { el: <AnalisiGoogleGrazie />, it: "/analisi-google/grazie", en: "/en/google-analysis/thanks" },
  { el: <Portfolio />, it: "/portfolio", en: "/en/portfolio" },
  { el: <PortfolioDetail />, it: "/portfolio/:slug", en: "/en/portfolio/:slug" },
  { el: <Contatti />, it: "/contatti", en: "/en/contact" },
  { el: <AdminPage />, it: "/admin", en: "/en/admin" },
  { el: <Shop />, it: "/shop", en: "/en/shop" },
  { el: <ProductDetail />, it: "/product/:slug", en: "/en/product/:slug" },
  { el: <CartPage />, it: "/cart", en: "/en/cart" },
  { el: <CheckoutPage />, it: "/checkout", en: "/en/checkout" },
  { el: <CheckoutSuccess />, it: "/checkout/success", en: "/en/checkout/success" },
  { el: <AccountPage />, it: "/account", en: "/en/account" },
  { el: <AccountLogin />, it: "/account/login", en: "/en/account/login" },
  { el: <AccountSetPassword />, it: "/account/imposta-password", en: "/en/account/set-password" },
  { el: <LegalPage />, it: "/pagine/:slug", en: "/en/pages/:slug" },
];

const AppLayout = () => {
  const location = useLocation();
  const path = location.pathname;
  const isHome = path === "/" || path === "/en";
  const isContatti = path === "/contatti" || path === "/en/contact";
  // Landing "nude" (campagne): niente sidebar, menu, carrello ne' footer del sito.
  const isBare = /^(\/en)?\/(analisi-google|google-analysis)(\/|$)/.test(path);

  const routes = (
    <Routes>
      {ROUTE_DEFS.flatMap((r) => [
        <Route key={r.it} path={r.it} element={r.el} />,
        <Route key={r.en} path={r.en} element={r.el} />,
      ])}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );

  if (isBare) {
    return (
      <div className="idm-app">
        <main className="idm-main idm-main-bare">{routes}</main>
      </div>
    );
  }

  return (
    <div className="idm-app">
      <Sidebar />
      <main className="idm-main">
        {routes}
        {!isHome && !isContatti && <Footer />}
      </main>
    </div>
  );
};

function App() {
  return (
    <HelmetProvider>
      <ShopProvider>
        <AuthProvider>
          <BrowserRouter>
            <LocaleProvider>
              <AppLayout />
              <Toaster position="bottom-right" richColors />
            </LocaleProvider>
          </BrowserRouter>
        </AuthProvider>
      </ShopProvider>
    </HelmetProvider>
  );
}

export default App;
